export interface Governorate {
  nameEn: string;
  nameAr: string;
}

export const EGYPT_GOVERNORATES: Governorate[] = [
  { nameEn: 'Cairo', nameAr: 'القاهرة' },
  {  nameEn: 'Alexandria', nameAr: 'الإسكندرية' },
  {  nameEn: 'Port Said', nameAr: 'بورسعيد' },
  { nameEn: 'Suez', nameAr: 'السويس' },
  {  nameEn: 'Damietta', nameAr: 'دمياط' },
  {  nameEn: 'Dakahlia', nameAr: 'الدقهلية' },
  {  nameEn: 'Sharqia', nameAr: 'الشرقية' },
  { nameEn: 'Qalyubia', nameAr: 'القليوبية' },
  {  nameEn: 'Kafr El Sheikh', nameAr: 'كفر الشيخ' },
  { nameEn: 'Gharbia', nameAr: 'الغربية' },
  {  nameEn: 'Monufia', nameAr: 'المنوفية' },
  {  nameEn: 'Beheira', nameAr: 'البحيرة' },
  {  nameEn: 'Ismailia', nameAr: 'الإسماعيلية' },
  {  nameEn: 'Giza', nameAr: 'الجيزة' },
  {  nameEn: 'Fayoum', nameAr: 'الفيوم' },
  {  nameEn: 'Beni Suef', nameAr: 'بني سويف' },
  {  nameEn: 'Minya', nameAr: 'المنيا' },
  {  nameEn: 'Asyut', nameAr: 'أسيوط' },
  {  nameEn: 'Sohag', nameAr: 'سوهاج' },
  {  nameEn: 'Qena', nameAr: 'قنا' },
  {  nameEn: 'Luxor', nameAr: 'الأقصر' },
  {  nameEn: 'Aswan', nameAr: 'أسوان' },
  {  nameEn: 'Red Sea', nameAr: 'البحر الأحمر' },
  {  nameEn: 'New Valley', nameAr: 'الوادي الجديد' },
  {  nameEn: 'Matrouh', nameAr: 'مطروح' },
  { nameEn: 'North Sinai', nameAr: 'شمال سيناء' },
  {  nameEn: 'South Sinai', nameAr: 'جنوب سيناء' }
];